// import composables
import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    isNavOpen: false,
    isSubNavOpen: false,
  }),

  actions: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    toggleSubNav() {
      this.isSubNavOpen = !this.isSubNavOpen;
    },
  },
});
